var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kgk-company-select"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.selectCompanyButton.apply(null, arguments)}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"button-text"},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" Firma auswählen")])
}]

export { render, staticRenderFns }